module.exports = __webpack_public_path__ + "static/media/new_top_sp.c3e9b167.jpg";